import React, { useEffect, useRef, useContext, use } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { ContextBoard } from "../context/ContextBoard";

const PrivateRoute10 = ({ children, tokenKey = "tokenclassx" }) => {
  const token = sessionStorage.getItem(tokenKey);
  const {
    setCandidateid10,
    setMode10,
    setDivyangcode10,
    setCastecode10,
    setClass10regulardata,
  } = useContext(ContextBoard);
  const location = useLocation();
  const navigate = useNavigate();
  const prevPath = useRef(location.pathname + location.search);

  useEffect(() => {
    const currentPath = location.pathname;
    const currentSearch = new URLSearchParams(location.search);
    const currentMode = currentSearch.get("mode");

    const prevURL = new URLSearchParams(prevPath.current.split("?")[1]);
    const prevPathname = prevPath.current.split("?")[0];
    const prevMode = prevURL.get("mode");

    // ✅ Case 1: Leaving regular-student/upload-document → clear all context
    if (
      (prevPathname === "/class-x-regular-student-info" ||
        prevPathname === "/class-x-upload-document") &&
      !(
        currentPath === "/class-x-regular-student-info" ||
        currentPath === "/class-x-upload-document"
      )
    ) {
      setCandidateid10("");
      setDivyangcode10("");
      setCastecode10("");
      setMode10("");
      setClass10regulardata(false);
    }

    // ✅ Case 2: Special case → upload-document → regular-student/add-ex-regular-student
    if (
      prevPathname === "/class-x-upload-document" &&
      (currentPath === "/class-x-regular-student-info" ||
        currentPath === "/class-x-add-ex-regular-student" ||
        currentPath === "/class-x-improvement-info")
    ) {
      setCandidateid10("");
      setDivyangcode10("");
      setCastecode10("");
      setMode10("");
      setClass10regulardata(false);
      navigate("/class-x-dashboard");
    }
    if (
      (prevPathname === "/class-x-correction-regular" ||
        prevPathname === "/class-x-upload-document") &&
      !(
        currentPath === "/class-x-correction-regular" ||
        currentPath === "/class-x-upload-document"
      )
    ) {
      setCandidateid10("");
      setDivyangcode10("");
      setCastecode10("");
      setMode10("");
      setClass10regulardata(false);
    }
    if (
      prevPathname === "/class-x-upload-document" &&
      (currentPath === "/class-x-correction-regular" ||
        currentPath === "/class-x-correction-exregular" ||
        currentPath === "/class-x-correction-improvement")
    ) {
      setCandidateid10("");
      setDivyangcode10("");
      setCastecode10("");
      setMode10("");
      setClass10regulardata(false);
      navigate("/class-x-dashboard");
    }
    // if (
    //   currentPath !== "/class-x-upload-document" &&
    //   (prevPathname !== "/class-x-regular-student-info" ||
    //     prevPathname !== "/class-x-add-ex-regular-student" ||
    //     prevPathname !== "/class-x-improvement-info")
    // ) {
    //   setCandidateid10("");
    //   setDivyangcode10("");
    //   setCastecode10("");
    //   setMode10("");
    //   setClass10regulardata(false);
    // }
    prevPath.current = location.pathname + location.search;
  }, [location]);
  if (!token) {
    return <Navigate to="/class-x" />;
  }

  return children;
};

export default PrivateRoute10;
